import { Colors } from '../consts/Colors.js';
import ButtonArrow from './buttons/ButtonArrow.js';

export default class EndScreen extends Phaser.GameObjects.Container {
    constructor(scene, txt, img, nextScene) {
        super(scene, 0, 0);
        scene.add.existing(this);
        this.scene = scene;
        this.txt = txt;
        this.img = img;
        this.nextScene = nextScene;

        this.elements = [];

        this.back = this.scene.add.rectangle(0, 0, 1920, 1080, Colors.Elmt.LightBlur, 0.6).setOrigin(0);
        this.add(this.back);

        this.title = this.scene.add.rexTagText(960, 250, "Bravo !", {
            fontSize: "128px",
            fontFamily: "Binx",
            align: "center",
            color: Colors.Text.Blue,
            backgroundColor: 'transparent',
            wordWrap: { width: 924 },
        }).setOrigin(0.5).setScale(0)
        this.add(this.title);
        this.elements.push(this.title);

        let firstTxt = "Tu as retrouvé les lettres du mot :"
        this.firstTxt = this.scene.add.rexTagText(960, 350, firstTxt, {
            fontSize: "48px",
            fontFamily: "Monteserrat",
            align: "center",
            color: Colors.Text.DarkBlue,
            backgroundColor: 'transparent',
            wordWrap: { width: 924 },
        }).setOrigin(0.5).setScale(0)
        this.add(this.firstTxt);
        this.elements.push(this.firstTxt);

        this.bottleImg = this.scene.add.image(960, 600, this.img).setOrigin(0.5).setAlpha(0).setScale(0)
        this.add(this.bottleImg);
        this.elements.push(this.bottleImg);

        this.secondTxt = this.scene.add.rexTagText(960, 900, this.txt, {
            fontSize: "48px",
            fontFamily: "Monteserrat",
            align: "center",
            color: Colors.Text.DarkBlue,
            backgroundColor: 'transparent',
            wordWrap: { width: 940 },
        }).setOrigin(0.5).setAlpha(0).setScale(0)
        this.add(this.secondTxt);
        this.elements.push(this.secondTxt);

        this.icon = this.scene.add.image(960 - this.secondTxt.width / 2 - 50, 880, 'exclamationIcon').setOrigin(0.5).setAlpha(0).setScale(0);
        this.add(this.icon);
        this.elements.push(this.icon);

        this.nxtBtn = new ButtonArrow(this.scene, 1780, 1020, 204, 56, "Suivant", "24px", true);
        this.nxtBtn.setAlpha(0)
        this.add(this.nxtBtn);
        this.nxtBtn.setClickFunction(() => {
            this.scene.scene.start(this.nextScene)
        })

    }

    launchAnim() {
        this.scene.tweens.add({
            targets: this.bottleImg,
            duration: 500,
            ease: 'Cubic.easeInOut',
            alpha: 1,
            scale: 1.2,
            onComplete: () => {
                this.elements.forEach((el, index) => {
                    this.scene.tweens.add({
                        targets: el,
                        duration: 500,
                        ease: 'Cubic.easeInOut',
                        scale: 1,
                        alpha: 1,
                        delay: index * 200,
                        onComplete: () => {
                            if (el === this.icon) {
                                this.nxtBtn.setAlpha(1);
                            }
                        }
                    });
                });
            }
        })
        //     onComplete: () => {
        //         this.scene.tweens.add({
        //             targets: this.secondTxt,
        //             duration: 500,
        //             ease: 'Cubic.easeInOut',
        //             alpha: 1,
        //             onComplete: () => {
        //                 this.scene.tweens.add({
        //                     targets: this.icon,
        //                     duration: 1000,
        //                     ease: 'Cubic.easeInOut',
        //                     alpha: 1,
        //                     onComplete: () => {

        //                     }
        //                 });
        //             }
        //         });
        //     }
        // });

    }
}
